let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2XRcq")).then(() => parcelRequire('3rrmj'));